import greiffPremiumRf from './GreiffPremiumRf.jpeg';

export const greiffPremiumRfImpressions = {
    greiffPremiumRf,
};
